export default __webpack_public_path__ + "static/paper-4cd3d50fb818e51247851c5615693204.svg";